import { FleetTable } from "../components/FleetTable/FleetTable"

const Fleets = () => {
    return (
        <div>
            <FleetTable />
        </div>
    );
}

export default Fleets;
